import styled from "styled-components";
import { SectionTitle } from "../index";

export const ModalTitle = styled(SectionTitle)`
  color: var(--main-title-text);
  text-align: center;
`;
